export const SET_ADDRESS = 'addressPage/SET_ADDRESS';
export const SUBMIT_ADDRESS = 'addressPage/SUBMIT_ADDRESS';
export const ADDRESS_SUBMITTED = 'addressPage/ADDRESS_SUBMITTED';
